/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <span class="navbar-advanced">
    <nav
      id="mobile-navbar"
      :ref="navRef"
      :class="(isSmallViewport) ? 'mobile-navbar navbar navbar-default' : 'navbar navbar-default'"
    >
      <div :class="(assignmentsEnabled && currentMode === 'manager' && isGroupManager) ? 'container-fluid navbar-teal' : 'container-fluid'">
        <div class="navbar-header">
          <a
            class="sr-only sr-only-focusable"
            style="color: white !important; font-size: 14pt;"
            href="#content"
          >
            Skip to main content
          </a>
          <record-button
            v-if="showSmallRecordButton"
            screen-size="small"
          />
          <profile-switcher
            v-if="showSmallModeSwitcher"
            count="1"
          />
          <a
            href="#navbar-collapse"
            class="navbar-toggle collapsed"
            aria-expanded="false"
            aria-controls="navbar"
            @click.prevent="collapsed = !collapsed"
          >
            <svg
              class="icon-menu"
              arial-label="Toggle navigation"
              aria-hidden="true"
            >
              <use xlink:href="/static/svg-symbols.svg#icon-menu" />
            </svg>
          </a>
          <a
            href="http://www.myvoicevibes.com"
            class="navbar-brand"
          >
            <img
              v-if="logoPath && logoPath !== 'btc' && logoPath !== 'vv'"
              alt="voicevibes logo"
              rel="homepage"
              :src="logoPath"
            >
            <svg
              v-else
              class="icon-btc"
              :style="logoPath === 'vv' ? 'height: 48px; width: 94px; padding: 0 5px;' : 'height: 40px; width: 140px;'"
            >
              <use :xlink:href="'/static/svg-symbols.svg#icon-' + logoPath" />
            </svg>
          </a>
        </div>

        <div
          class="navbar-collapse collapse"
          :class="{ in: !collapsed }"
        >
          <ul
            v-if="isAuthenticated"
            class="nav navbar-nav navbar-left"
            @click="collapsed = true;"
          >
            <li
              v-if="assignmentsEnabled && (isGroupManager && currentMode == 'manager')"
              :class="{ active: activeRoute === 'coach-dashboard' }"
            >
              <router-link
                id="dashboardLink"
                :to="{ name: 'coach-dashboard' }"
                :aria-current="activeRoute === 'coach-dashboard' ? 'true' : 'false'"
              >
                Dashboard
              </router-link>
            </li>
            <li
              v-else-if="assignmentsEnabled && isSpeaker"
              :class="{ active: activeRoute === 'speaker-dashboard' }"
            >
              <router-link
                id="dashboardLink"
                :to="{ name: 'speaker-dashboard' }"
                :aria-current="activeRoute === 'speaker-dashboard' ? 'true' : 'false'"
              >
                Dashboard
              </router-link>
            </li>
            <li
              v-if="isSpeaker && !(assignmentsEnabled && isGroupManager && currentMode == 'manager')"
              :class="{ active: activeRoute === 'record' }"
            >
              <router-link
                :to="{ name: 'record' }"
                :aria-current="activeRoute === 'record' ? 'true' : 'false'"
              >
                Record
              </router-link>
            </li>
            <li
              v-if="isSpeaker && !(assignmentsEnabled && isGroupManager && currentMode == 'manager')"
              :class="{ active: activeRoute === 'evaluate' }"
            >
              <router-link
                :to="{ name: 'evaluate' }"
                :aria-current="activeRoute === 'evaluate' ? 'true' : 'false'"
              >
                Results
              </router-link>
            </li>
            <li
              v-if="isSpeaker || isGroupManager"
              :class="{ active: activeRoute === 'history' }"
            >
              <router-link
                :to="{ name: 'history' }"
                :aria-current="activeRoute === 'history' ? 'true' : 'false'"
              >
                History
              </router-link>
            </li>
            <li
              v-if="!assignmentsEnabled"
              :class="{ active: activeRoute === 'manage' }"
            >
              <router-link
                :to="{ name: 'manage' }"
                :aria-current="activeRoute === 'manage' ? 'true' : 'false'"
              >
                Manage
              </router-link>
            </li>
            <li
              v-if="isOrgLevelAdmin && !(assignmentsEnabled && currentMode == 'speaker')"
              :class="{ active: activeRoute.indexOf('customer-admin') === 0 }"
            >
              <router-link
                :to="{ name: 'customer-admin-groups' }"
                :aria-current="activeRoute.indexOf('customer-admin') === 0 ? 'true' : 'false'"
              >
                Admin
              </router-link>
            </li>
            <li
              :class="{ active: activeRoute === 'help' }"
            >
              <router-link
                :to="{ name: 'help' }"
                :aria-current="activeRoute === 'help' ? 'true' : 'false'"
              >
                Help
              </router-link>
            </li>
          </ul>
          <div
            v-if="isAuthenticated"
            class="navbar-right text-right text-nowrap"
          >
            <span
              v-if="user"
              class="navbar-text hidden-xs"
            >
              <span class="hidden-sm">
                Logged in as
              </span>
              <router-link
                id="userProfileLink"
                :to="{ name: 'profile' }"
              >
                {{ user.name }}
              </router-link>
            </span>
            <profile-switcher
              v-if="showLargeModeSwitcher"
              count="2"
            />

            <router-link
              class="btn btn-default navbar-btn"
              :to="{ name: 'sign-out' }"
            >
              Sign out
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <div :class="(isSmallViewport) ? 'navbar-bumper' : 'hidden-nav'">
&nbsp;
    </div>
  </span>
</template>

<style lang="less" scoped>
.icon-menu {
  height: 20px; width: 20px;
  padding: 0;
  margin: 0;
}
.navbar-toggle {
  padding: 8px 5px 5px 5px;
}
</style>

<script>
import RecordButton from '../forms/RecordButton';
import ProfileSwitcher from '../specials/ProfileSwitcher';
import AssignmentModes from '../specials/AssignmentModes';
import util from '../utils/util';

export default {
  components: { RecordButton, ProfileSwitcher },
  mixins: [ AssignmentModes ],
  data() {
    return {
      collapsed: true,
      navRef: 1,
    };
  },
  computed: {
    logoPath: {
      cache: false,
      get() {
        const logo = (this.$store.getters.org && this.$store.getters.org.whiteLabelLogo) ?
          this.$store.getters.org.whiteLabelLogo : null;

        // Logos rendered from main SVG file
        if (logo === 'btc') return 'btc';
        if (!logo) return 'vv';

        // White label logo URL
        return 'https://voicevibes.s3.amazonaws.com/static/images/' + logo;
      }
    },
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
    showSmallRecordButton: {
      cache: false,
      get() {
        return (this.isSpeaker && this.isSmallViewport && !this.isRecordingPage &&
          !(this.assignmentsEnabled && this.isGroupManager && this.currentMode == 'manager'));
      }
    },
    showLargeModeSwitcher: {
      cache: false,
      get() {
        return (this.assignmentsEnabled && this.isGroupManager && this.isSpeaker);
      }
    },
    showSmallModeSwitcher: {
      cache: false,
      get() {
        return (!this.showSmallRecordButton && this.showLargeModeSwitcher && this.isSmallViewport);
      }
    },
    isRecordingPage() {
      return (this.$route.name === 'record');
    },
    isOrgLevelAdmin: {
      cache: false,
      get() {
        return (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('admin') !== -1);
      }
    },
    isOrgLevelManager() {
      return (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('manager') !== -1);
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    activeRoute() {
      return this.$route.meta.menu || this.$route.name || '';
    },
    assignmentsEnabled() {
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Assignments);
    },
    managedGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'manager');
        });
      }
    },
    speakerGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'speaker');
        });
      }
    },
    isGroupManager: {
      cache: false,
      get() {
        return this.managedGroups.length > 0 ||
          (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('manager') !== -1);
      }
    },
    isSpeaker: {
      cache: false,
      get() {
        return this.speakerGroups.length > 0;
      }
    },
    user: {
      cache: false,
      get() {
        return this.$store.getters.user;
      }
    },
  },
  created() {
    window.addEventListener('resize', () => {
      this.$forceUpdate();
    });
  },
  updated() {
    // This is needed for pages which don't call this method otherwise
    this.loadCurrentModeFromPreferences();
  },
};
</script>
